import React from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Box,
} from "@mui/material";

const headerCellSx = {
  fontWeight: 600,
  fontSize: "0.8rem",
  color: "#475569",
  backgroundColor: "#f1f5f9",
  borderBottom: "2px solid #e2e8f0",
  py: 1.5,
};

const ListadoDeIngresos = ({ productos, withDeclared = false }) => {
  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        borderRadius: "10px",
        border: "1px solid #e2e8f0",
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={headerCellSx}>SKU</TableCell>
            <TableCell sx={headerCellSx}>Descripción</TableCell>
            <TableCell align="center" sx={headerCellSx}>
              Declarada
            </TableCell>
            {withDeclared && (
              <TableCell align="center" sx={headerCellSx}>
                Ingresada
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {productos.map((element, index) => {
            const declared = element.original_count || element.amountEntered;
            const entered = element.effective_count;
            const hasDifference = withDeclared && declared !== entered;

            return (
              <TableRow
                key={element.sku_id}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#fff" : "#fafbfc",
                  "&:last-child td": { borderBottom: 0 },
                }}
              >
                <TableCell sx={{ py: 1.2 }}>
                  <Chip
                    label={element.sku_id}
                    size="small"
                    sx={{
                      fontWeight: 600,
                      fontSize: "0.75rem",
                      backgroundColor: "#E8F0FE",
                      color: "#3949ab",
                    }}
                  />
                </TableCell>
                <TableCell sx={{ py: 1.2 }}>
                  <Typography variant="body2" sx={{ fontWeight: 500 }}>
                    {element.description || element.name}
                  </Typography>
                </TableCell>
                <TableCell align="center" sx={{ py: 1.2 }}>
                  <Typography variant="body2" fontWeight={500}>
                    {declared}
                  </Typography>
                </TableCell>
                {withDeclared && (
                  <TableCell align="center" sx={{ py: 1.2 }}>
                    <Typography
                      variant="body2"
                      fontWeight={600}
                      sx={{
                        color: hasDifference ? "#e65100" : "#2e7d32",
                      }}
                    >
                      {entered}
                    </Typography>
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ListadoDeIngresos;
